import { Modal, List, Typography, Tag } from 'antd'
import { tourStepsConfig } from '../../../config/tourConfig'
const { Title, Paragraph } = Typography

export const FeaturesModal = ({ open, onClose, onStartTour }) => {
    return (
        <Modal
            open={open}
            onOk={onStartTour}
            okText="Take a Tour"
            closable={false}
            centered
            width={600}
            className='tour-modal'
            bodyStyle={{
                padding: '24px 32px',
                background: '#fdfdfd',
                borderRadius: '12px',
            }}
            style={{
                borderRadius: '12px',
                overflow: 'hidden',
            }}
            footer={
                <div style={{ display: 'flex', justifyContent: 'center' }} >
                    <button
                        key="takeTour"
                        onClick={onStartTour}
                        className='modal-footer-btn'
                    >
                        Take a Tour
                    </button>
                </div>
            }
        >
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
                <Title level={3} style={{ marginBottom: 8, color: "#9E8B5B" }}>
                    🎉 What’s New
                </Title>
                <Paragraph type="secondary">We’ve rolled out some exciting updates to improve your experience.</Paragraph>
            </div>

            <List
                itemLayout="horizontal"
                dataSource={Object.values(tourStepsConfig)}
                renderItem={(item) => (
                    <List.Item
                        style={{
                            background: '#fff',
                            borderRadius: 8,
                            marginBottom: 12,
                            padding: '12px 16px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        }}
                    >
                        <List.Item.Meta
                            avatar={item.icon}
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span>{item.title}</span>
                                    <Tag color="blue">{item.tag}</Tag>
                                </div>
                            }
                            // description={item.description}
                        />
                    </List.Item>
                )}
            />
        </Modal>
    )
}
